/*
 * @Author: Branton
 * @Date: 2025-10-28 17:01:49
 * @LastEditTime: 2025-10-28 17:42:58
 * @LastEditors: Branton
 * @Description:
 * @FilePath: \Rms-Tender-Frontend\src\components\tabs\index.tsx
 * 暂无
 */
import { Tabs, TabsProps } from 'antd';
import { forwardRef } from 'react';

const ZeissTabs = (props: TabsProps): any => {
  const { className, ...rest } = props;

  return <Tabs className={`${className} zeiss-reset-tabs`} {...rest} />;
};

export default forwardRef(ZeissTabs);
